export * from './bottom-menu.component';
